
class CapViewStudentNotes {
  constructor(config) {
    this.config = config
  }
  
  // eslint-disable-next-line
  checkPermission(options = {}) {
    return Boolean(this.config)
  }
}

function key() {
  return 'view_student_notes'
}

function create(config) {
  return new CapViewStudentNotes(config)
}

export default {
  key,
  create,
}
